export default __webpack_public_path__ + "static/media/plain-sticker-O.95993772.png";